import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const LanguagePicker = ({ variant = 'default' }) => {
  const { language, setLanguage, availableLanguages } = useLanguage();
  
  const currentLang = availableLanguages.find(l => l.code === language) || availableLanguages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant === 'outline' ? 'outline' : 'ghost'}
          size="sm"
          className={`flex items-center gap-2 font-bold ${
            variant === 'outline' 
              ? 'border-2 hover:border-[#84bc00] hover:bg-[#84bc00]/10' 
              : 'hover:bg-white/10'
          }`}
          data-testid="language-picker"
        >
          <Globe size={16} />
          <span className="hidden sm:inline">{currentLang.flag} {currentLang.code.toUpperCase()}</span>
          <span className="sm:hidden">{currentLang.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {availableLanguages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`cursor-pointer flex items-center gap-2 ${
              language === lang.code ? 'bg-[#84bc00]/10 text-[#84bc00] font-bold' : ''
            }`}
            data-testid={`language-option-${lang.code}`}
          >
            <span className="text-lg">{lang.flag}</span>
            <span>{lang.name}</span>
            {language === lang.code && (
              <span className="ml-auto text-[#84bc00]">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguagePicker;
